export default __webpack_public_path__ + "static/media/Skillssubmenu.fe64e273.webp";